<template lang="pug">
  .easy-week-wrapper.card
    EasyWeeks(
      v-for="(data, plate) in vehicles" :key="plate"
      :shifts="data.shifts"
      :reservations="data.reservations"
      :plate="plate"
      :daysToShow="daysToShow"
    )

</template>

<script>
  import EasyWeeks from "./EasyWeek"
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice"
  import moment from "moment";
  import collect from "collect.js"

  export default {
    name: "EasyWeeksWrapper",
    components: {EasyWeeks},
    props: {
      daysToShow: {type: Number, default: 14},
      autoShift: {type: Number, default: 0},
      hourOffset: {type: Number, default: 0},
    },
    data() {
      return {
        vehicles: null,
        loading: false
      }
    },
    created() {
      this.init()
    },
    watch: {
      daysToShow: function (val, oldVal) {
        if (val !== oldVal && !this.loading) {
          this.init()
        }
      },
      hourOffset: function (val, oldVal) {
        if (val !== oldVal && !this.loading) {
          this.init()
          localStorage.setItem("hourOffset", val)
        }
      },
      autoShift: function (val, oldVal) {
        if (val !== oldVal && !this.loading) {
          this.init()
          localStorage.setItem("shiftCount", val)
        }
      },
    },
    methods: {
      init() {
        this.loading = true
        KeplerBackofficeSdk.reservations.list(1, 1000, {
          from: moment().format('Y-MM-DD'),
          to: moment().add(this.daysToShow, "days").format('Y-MM-DD'),
          // order_direction: 'DESC',
          status: "STARTED|CONFIRMED|PLANNED|SENT"
        }).all((data) => {

          this.vehicles = collect(data.items.map(i => {
            if (i) {
              return {
                start: i.start,
                end: i.end,
                reservation_id: i.id,
                driver_id: i.driver.id,
                plate: i.vehicle.plate,
                status: i.status,
                memo: i.memo
              }
            }
          })).groupBy('plate').map(resGroup => {
            let shifts = {}
            const reservations = []
            resGroup.forEach(i => {
              if (this.autoShift == 0) {
                let m
                if (i.memo && typeof i.memo === "string") {
                  m = i.memo.split(' ')[0]
                } else {
                  m = 'no_memo'
                }

                const start = moment(i.start).format('HH:mm')
                  const end = moment(i.end).format('HH:mm')
                  const id = (start + '' + end).replaceAll(':', '')
                  const shift = {
                    id: id,
                    name: m,
                    start: start,
                    end: end,
                    duration: moment(i.end).diff(moment(i.start), 'minutes'),
                    color: '',
                  }

                if (!shifts.hasOwnProperty(id)) {
                  shifts[id] = shift
                }
              } else {
                shifts = []
                let numberOfShifts = 1440 / 30

                numberOfShifts = this.autoShift > 24 ? 24 : this.autoShift

                let counter = 0

                let increment = 1440 / numberOfShifts

                while (counter < 1440) {
                  let s = moment().startOf("day").hour(this.hourOffset).add(counter, "minutes")
                  counter += increment
                  let e = s.clone().add(increment, "minutes")

                  shifts.push({
                      id: s.format("HHmm")+e.format("HHmm"),
                      name: "T"+(shifts.length+1),
                      start: s.format("HH:mm"),
                      end: e.format("HH:mm"),
                      duration: increment,
                      color: '',
                    })
                }
              }
              reservations.push(i)
            })

            this.loading = false

            return {
              shifts: collect(!Array.isArray(shifts) ? Object.values(shifts) : shifts).sortBy('id').all(),
              reservations: collect(reservations).sortBy((i)=> {
                return i.start
              }).all(),
            }

          }).all()
        })
      }
    }
  }
</script>

<style lang="sass">
  .easy-week-wrapper
    width: 100%
    padding: 1em

    .easy-week-component:not(:first-child)
      margin-top: 1em
      padding-top: .5em
      border-top: 1px solid #ccc
</style>



// WEBPACK FOOTER //
// EasyWeeksWrapper.vue?6b508e2a